import { render } from "./Stipend_List_Poor.vue?vue&type=template&id=3d077afb&ts=true"
import script from "./Stipend_List_Poor.vue?vue&type=script&lang=ts"
export * from "./Stipend_List_Poor.vue?vue&type=script&lang=ts"

import "./Stipend_List_Poor.vue?vue&type=style&index=0&id=3d077afb&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__